import * as vp from 'vopay';
import * as Yup from 'yup';
import { FunctionComponent } from 'react';
import { Formik } from 'formik';
import { useTranslation } from 'react-i18next';
import buildUpdateAuthorizedIpsRowsRows from './buildUpdateAuthorizedIpsRows.helper';

const { Box, Button, Title, Table, TextField } = vp;

type UpdateAuthorizedIpsProps = {
  onSubmit: (params: vp.SaveAuthorizedIPsRequest) => void;
  defaultValues: vp.SaveAuthorizedIPsRequest;
};
type FC = FunctionComponent<UpdateAuthorizedIpsProps>;

const UpdateAuthorizedIps: FC = (props: UpdateAuthorizedIpsProps) => {
  const { onSubmit, defaultValues } = props;
  const { t } = useTranslation('translations', { keyPrefix: 'Settings' });
  const updateAuthorizedIpsRows = buildUpdateAuthorizedIpsRowsRows();
  return (
    <Formik
      enableReinitialize
      initialValues={defaultValues}
      onSubmit={onSubmit}
      validationSchema={createdValidationSchema()}
      validateOnChange
      validateOnBlur
    >
      {({ values, touched, errors, handleChange, handleBlur, handleSubmit }) => {
        const updateAuthorizedIpsTable: vp.TableProps = {
          name: 'update-AuthorizedIps-fields',
          variant: 'pair',
          columns: {
            Field: { header: t('AuthorizedIps.Form.labels', { defaultValue: 'Labels' }) },
            Input: { header: t('AuthorizedIps.Form.fields', { defaultValue: 'Fields' }) },
          },
          rows: updateAuthorizedIpsRows.map(({ label, id, preset }) => ({
            Field: label,
            Input: (
              <TextField
                preset={preset}
                key={id}
                name={id}
                variant="standard"
                onBlur={handleBlur}
                onChange={handleChange}
                value={values[id]}
                error={errors[id] && touched[id] ? errors[id] : null}
              />
            ),
          })),
        };
        return (
          <form onSubmit={handleSubmit}>
            <Box mb="md" jc="sb">
              <Title title={t('AuthorizedIps.title', { defaultValue: 'Authorize IP Addresses' })} />
            </Box>
            <Table {...updateAuthorizedIpsTable} />
            <Box mt="md" jc="fe">
              <Button id="AuthorizedIps-review" type="submit" label={t('AuthorizedIps.Form.reviewButton', { defaultValue: 'Review' })} />
            </Box>
          </form>
        );
      }}
    </Formik>
  );
  function createdValidationSchema() {
    return Yup.object().shape({
      AuthorizedIPs: Yup.string().required(t('AuthorizedIps.Form.validation', { defaultValue: 'Please provide Authorize IP Addresses.' })),
    });
  }
};

export default UpdateAuthorizedIps;
